import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// internalOnly: i client_user vengono reindirizzati al loro portale.
export function ProtectedRoute({ children, internalOnly = false }) {
  const { isAuthenticated, isClient, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background" data-testid="auth-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-muted border-t-foreground" />
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (internalOnly && isClient) return <Navigate to="/portal" replace />;
  return children;
}
